import { render, staticRenderFns } from "./KpiBig.vue?vue&type=template&id=72ed7518"
import script from "./KpiBig.vue?vue&type=script&lang=js"
export * from "./KpiBig.vue?vue&type=script&lang=js"
import style0 from "./KpiBig.vue?vue&type=style&index=0&id=72ed7518&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports